export default {
    btnOk: 'OK',
    btnCancel: 'CANCEL'
}
